<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Login</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Login-muligheder</dt>
        @for (mode of value.modes; track mode) {
          <dd>
            @switch (mode) {
              @case ('mitid') {
                <span>MitID</span>
              }
              @case ('nemid') {
                <span>NemID</span>
              }
              @case ('codefile') {
                <span>NemID-nøglefil</span>
              }
              @case ('tfa') {
                <span>Brugernavn/Adgangskode + to-faktor</span>
              }
              @case ('sso') {
                <span>Single Sign On</span>
              }
            }
          </dd>
        }
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <label>Login-metoder</label>
      <mat-form-field class="mb-3" fxFill>
        <mat-select formControlName="modes" multiple>
          <mat-option value="mitid">MitID</mat-option>
          <mat-option value="nemid">NemID</mat-option>
          <mat-option value="codefile">NemID-nøglefil</mat-option>
          <mat-option value="tfa">Brugernavn/Adgangskode + to-faktor</mat-option>
          <mat-option value="sso">Single Sign In</mat-option>
        </mat-select>
        <mat-hint>Vælg de metoder, som svarer til fondens behov.</mat-hint>
        @if (form.controls['modes'].hasError('required')) {
          <mat-error>Obligatorisk.</mat-error>
        }
      </mat-form-field>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
